import { loadable } from '../../common/utils/lazyLoading';
import FacilityManagementStructure from './FacilityManagementStructure';
const FacilityManagementPage = loadable(() => import('./FacilityManagementPage'));
export default {
    id: 'facility_management',
    title: 'Facility Management',
    icon: 'ed-facility-management',
    iconType: 'ed',
    route: 'facility-management',
    defaultRoute: 'facility-management/asset-register',
    hasDynamicDefaultRoute: true,
    component: FacilityManagementPage,
    group: 'administration',
    order: 5,
    structure: FacilityManagementStructure,
};
